// extracted by mini-css-extract-plugin
module.exports = {"legacyBlogContent":"LegacyBlogContent_legacyBlogContent__8_V9U table_table__yNSOR"};